var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-server-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.load_first,
              expression: "load_first"
            }
          ],
          ref: "privilegesTableComponent",
          staticClass: "jTable table-access-application table-access-privilege",
          attrs: { columns: _vm.columns, options: _vm.option },
          on: { loading: _vm.loading, loaded: _vm.loaded },
          scopedSlots: _vm._u([
            {
              key: "id",
              fn: function(props) {
                return _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.openDetail(props.row)
                      }
                    }
                  },
                  [_vm._v("\n      " + _vm._s(props.row.id) + "\n    ")]
                )
              }
            },
            {
              key: "name",
              fn: function(props) {
                return _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.openDetail(props.row)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        { staticClass: "td" },
                        [
                          props.row.photo_url
                            ? _c("b-img", {
                                staticClass:
                                  "m-1 round-bordered-img\n            img-circle staff-img image-popup-link b-page-theme td",
                                attrs: {
                                  src: props.row.photo_url,
                                  rounded: "circle",
                                  alt: "img"
                                }
                              })
                            : _c("b-img", {
                                staticClass:
                                  "m-1 round-bordered-img\n            img-circle staff-img image-popup-link b-page-theme td",
                                attrs: {
                                  src: require("@/assets/logo/user1.png"),
                                  rounded: "circle",
                                  alt: "img"
                                }
                              })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "td p__t--7" }, [
                        _c("div", { staticClass: "f--14" }, [
                          _vm._v(_vm._s(props.row.organigram_name))
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(props.row.employee_name))])
                      ])
                    ])
                  ]
                )
              }
            },
            {
              key: "email",
              fn: function(props) {
                return _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.openDetail(props.row)
                      }
                    }
                  },
                  [_vm._v("\n      " + _vm._s(props.row.email) + "\n    ")]
                )
              }
            },
            {
              key: "action",
              fn: function(props) {
                return _c("div", {}, [
                  _c(
                    "div",
                    {
                      staticClass: "action-table-access-application",
                      on: {
                        click: function($event) {
                          _vm.viewAccess(props.row)
                        }
                      }
                    },
                    [_vm._v("\n        View Access\n      ")]
                  )
                ])
              }
            },
            {
              key: "created_at",
              fn: function(props) {
                return _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.openDetail(props.row)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.convertDateTime(props.row.created_at)) +
                        "\n    "
                    )
                  ]
                )
              }
            },
            {
              key: "updated_at",
              fn: function(props) {
                return _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.openDetail(props.row)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.convertDateTime(props.row.updated_at)) +
                        "\n    "
                    )
                  ]
                )
              }
            },
            {
              key: "delete",
              fn: function(props) {
                return _c("div", {}, [
                  _c("i", {
                    staticClass: "fa fa-lg fa-trash cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.deleteUser(props.row)
                      }
                    }
                  })
                ])
              }
            }
          ])
        },
        [
          _c(
            "div",
            {
              staticClass: "custom-search",
              attrs: { slot: "beforeFilter" },
              slot: "beforeFilter"
            },
            [
              _c(
                "b-form",
                { attrs: { inline: "" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn grey btn-import-form m__r--5",
                      on: {
                        click: function($event) {
                          _vm.$refs.addPrivilegeModal.show()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus fa-lg" }),
                      _vm._v(" Add\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      attrs: { inline: "" },
                      on: {
                        keypress: function($event) {
                          if (!("button" in $event) && $event.keyCode !== 13) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.filter(_vm.filter_data)
                        }
                      }
                    },
                    [
                      _c("b-form-select", {
                        staticClass: "m__r--5",
                        attrs: {
                          options: _vm.options_search,
                          placeholder: "Filter By"
                        },
                        model: {
                          value: _vm.select_type,
                          callback: function($$v) {
                            _vm.select_type = $$v
                          },
                          expression: "select_type"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-form-input", {
                        ref: "filterInput",
                        staticStyle: { width: "250px", height: "35px" },
                        attrs: { placeholder: "Search" },
                        model: {
                          value: _vm.filter_data,
                          callback: function($$v) {
                            _vm.filter_data = $$v
                          },
                          expression: "filter_data"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      !_vm.load_first ? _c("jLoadingTable") : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "addPrivilegeModal",
          staticClass: "mod-form modal-access",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _vm.isViewAccess
            ? _c(
                "div",
                {
                  staticClass: "close-modal-oos",
                  on: { click: _vm.closeAddPrivilege }
                },
                [_vm._v("X")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v(_vm._s(_vm.isViewAccess ? "VIEW ACCESS" : "ADD PRIVILEGES"))
          ]),
          _vm._v(" "),
          !_vm.isViewAccess
            ? _c(
                "div",
                [
                  _c(
                    "b-form-group",
                    [
                      _c("label", [_vm._v("Position Name")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          "is-async": true,
                          "cache-options": false,
                          "load-options": _vm.loadUserOptions,
                          placeholder: "Select",
                          "error-required": false,
                          "value-format": "object",
                          label: "name"
                        },
                        model: {
                          value: _vm.user_organigram,
                          callback: function($$v) {
                            _vm.user_organigram = $$v
                          },
                          expression: "user_organigram"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.user_organigram &&
                  _vm.user_organigram.user &&
                  _vm.user_organigram.user.profile
                    ? _c(
                        "b-row",
                        { staticClass: "rectangle-rule-access" },
                        [
                          _c("b-col", { attrs: { md: "1" } }, [
                            _vm.user_organigram.user.profile.photo_url
                              ? _c("img", {
                                  staticClass: "card-assignee-photo-modal",
                                  attrs: {
                                    title:
                                      _vm.user_organigram.user.profile
                                        .first_name,
                                    src:
                                      _vm.user_organigram.user.profile.photo_url
                                  }
                                })
                              : _c(
                                  "span",
                                  {
                                    staticClass: "card-assignee-initial-modal",
                                    attrs: {
                                      title:
                                        _vm.user_organigram.user.profile
                                          .first_name
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.getUserInitial(
                                            _vm.user_organigram.user.profile
                                          )
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                )
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "11" } }, [
                            _c("span", { staticClass: "label-position" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.user_organigram.user.profile.first_name
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.user_organigram.user.profile.last_name
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.user_organigram.user.profile.email) +
                                "\n        "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm.user_organigram &&
                  _vm.user_organigram.user &&
                  _vm.user_organigram.user.profile
                    ? _c(
                        "b-row",
                        { staticClass: "rectangle-rule-view-access" },
                        [
                          _c("b-col", { attrs: { md: "1" } }, [
                            _vm.user_organigram.user.profile.photo_url
                              ? _c("img", {
                                  staticClass: "card-assignee-photo-modal",
                                  attrs: {
                                    title:
                                      _vm.user_organigram.user.profile
                                        .first_name,
                                    src:
                                      _vm.user_organigram.user.profile.photo_url
                                  }
                                })
                              : _c("img", {
                                  staticClass: "card-assignee-photo-modal",
                                  attrs: {
                                    title:
                                      _vm.user_organigram.user.profile
                                        .first_name,
                                    src: require("@/assets/logo/user1.png")
                                  }
                                })
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "11" } }, [
                            _c("span", { staticClass: "label-position" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.user_organigram.user.profile.first_name
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.user_organigram.user.profile.last_name
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _vm.user_organigram.user.profile.first_name ||
                            _vm.user_organigram.user.profile.last_name
                              ? _c("br")
                              : _vm._e(),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.user_organigram.name) +
                                "\n        "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { md: "6" } }, [
                        _c("div", { staticClass: "label-pages-privileges" }, [
                          _vm._v("PAGES")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { md: "6" } }, [
                        _c(
                          "span",
                          {
                            staticClass: "enable-pages-privileges pull-right",
                            on: { click: _vm.disableAll }
                          },
                          [_vm._v("Disable All")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "enable-pages-privileges pull-right m__r--10",
                            on: { click: _vm.enableAll }
                          },
                          [_vm._v("Enable All")]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.listPages.length > 0
                    ? _c("jPagesList", {
                        attrs: {
                          "list-pages": _vm.listPages,
                          type: "privilege"
                        },
                        on: { "change-toggle": _vm.changeToggle }
                      })
                    : _vm._e()
                ],
                1
              ),
          _vm._v(" "),
          !_vm.isViewAccess
            ? _c(
                "b-row",
                { staticClass: "m__t--5" },
                [
                  _c("b-col", { attrs: { md: "6" } }),
                  _vm._v(" "),
                  _c("b-col", { attrs: { md: "6" } }, [
                    _c(
                      "div",
                      { staticClass: "float-to-right" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn gray m__r--5",
                            on: { click: _vm.closeAddPrivilege }
                          },
                          [_vm._v("\n            Close\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "btn blue",
                            attrs: { disabled: !_vm.user_organigram },
                            on: { click: _vm.confirmPrivilege }
                          },
                          [_vm._v("\n            Confirm\n          ")]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("j-progress", {
        ref: "progressMappingPage",
        attrs: {
          "data-kirim": _vm.data_selected,
          "url-api": _vm.url_mapping_page,
          headers: _vm.headers
        },
        on: { finish: _vm.finishActionPage }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4aefddd9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aefddd9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/access/tab/jAccessApplicationTabPrivilege.vue
// module id = null
// module chunks = 